import {
	endpointsMap,
	ICollectBasketOptions,
	ICollectBasketResponse,
	IGenerateUrlOptions,
	IGenerateUrlResponse
} from './ICustomShopperPersonalShopper';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperPersonalShopper
 */
class CustomShopperPersonalShopper extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Generates an URL for collecting a saved cart
	 * @param {IGenerateUrlOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGenerateUrlResponse} - URL for collecting a saved cart
	 */
	public async generateUrl(fetchOptions: IGenerateUrlOptions, throwOnError?: boolean): Promise<IGenerateUrlResponse> {
		const response: IGenerateUrlResponse = await this.callCustomEndpoint<IGenerateUrlResponse>(
			fetchOptions,
			endpointsMap.GENERATE_URL
		);

		if (throwOnError && (response.collectBasketURL)) {
			throw new Error('No customer groups returned.');
		}

		return response;
	}

	/**
	 * Retrieves a saved cart and redirect to the cart page
	 * @param {ICollectBasketOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {ICollectBasketResponse} - redirect URL to the cart page
	 */
	public async collectBasket(fetchOptions: ICollectBasketOptions, throwOnError?: boolean): Promise<ICollectBasketResponse> {
		const response: ICollectBasketResponse = await this.callCustomEndpoint<ICollectBasketResponse>(
			fetchOptions,
			endpointsMap.COLLECT_BASKET
		);

		if (throwOnError && !response.redirectUrl) {
			throw new Error('No customer groups returned.');
		}

		return response;
	}
}

export default CustomShopperPersonalShopper;
